import React from 'react'
import BaseIcon from 'react-icon-base'

const ES = props => (
  <BaseIcon width={21} height={15} viewBox="0 0 21 15" {...props}>
    <title>ES</title>
    <defs>
      <rect id="es_svg__a" width={21} height={15} rx={2} />
      <rect id="es_svg__d" width={20} height={14} x={0.5} y={0.5} rx={1} />
      <filter id="es_svg__b" width="104.8%" height="106.7%" x="-2.4%" y="-3.3%" filterUnits="objectBoundingBox">
        <feMorphology in="SourceAlpha" radius={1} result="shadowSpreadInner1" />
        <feOffset in="shadowSpreadInner1" result="shadowOffsetInner1" />
        <feComposite
          in="shadowOffsetInner1"
          in2="SourceAlpha"
          k2={-1}
          k3={1}
          operator="arithmetic"
          result="shadowInnerInner1"
        />
        <feColorMatrix in="shadowInnerInner1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.121659873 0" />
      </filter>
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="es_svg__c" fill="#fff">
        <use xlinkHref="#es_svg__a" />
      </mask>
      <use fill="#FFD128" xlinkHref="#es_svg__a" />
      <use fill="#000" filter="url(#es_svg__b)" xlinkHref="#es_svg__a" />
      <path
        fill="#CF3F4F"
        d="M0 11h21v4H0zM0 0h21v4H0zm4 5h3c.556 0 1 .448 1 1v3c0 .556-.448 1-1 1H4c-.556 0-1-.448-1-1V6c0-.556.448-1 1-1zm0 1v3h3V6H4zm1 0h1v3H5V6z"
        mask="url(#es_svg__c)"
      />
      <path fill="#DC6943" d="M6 7h1v1H6V7zM4 6h1v1H4V6z" mask="url(#es_svg__c)" />
      <use stroke="#2F343A" strokeOpacity={0.157} xlinkHref="#es_svg__d" />
    </g>
  </BaseIcon>
)

export default ES
